import m from "mithril";
import DateUtilities from "../../shared/utilities/date_utilities";
import { CalendarDay } from '@mithril-icons/font-awesome/solid';
import { Datepicker } from "vanillajs-datepicker";

const DateInput = {
    oninit: function (vnode) {
        vnode.state.datepicker = null;
    },

    oncreate: function (vnode) {
        const { field, i18n, invalidDateFieldIds, dirtyFlag } = vnode.attrs;
        const input = vnode.dom.querySelector("input");
        const button = vnode.dom.querySelector("button");

        const dateFormat = DateUtilities.getLocaleDateString(i18n.locale).toLowerCase();

        // Initialize datepicker
        const dp = new Datepicker(input, {
            language: i18n.locale,
            format: dateFormat,
            updateOnBlur: false,
            showOnFocus: false,
            showOnClick: false,
            container: ".modal"
        });

        vnode.state.datepicker = dp;

        // Use mousedown + preventDefault so the input doesn't blur before show() runs
        button.addEventListener("mousedown", function (e) {
            e.preventDefault();
            dp.active ? dp.hide() : dp.show();
        });

        // Update value when a date is selected
        input.addEventListener("changeDate", function () {
            field.value = input.value;
            dirtyFlag(true);

            const idx = invalidDateFieldIds.indexOf(field.id);
            if (idx !== -1) invalidDateFieldIds.splice(idx, 1);

            m.redraw();
        });
    },

    view: function (vnode) {
        const { field, i18n, invalidDateFieldIds, dirtyFlag } = vnode.attrs;
        const dateFormat = DateUtilities.getLocaleDateString(i18n.locale).toLowerCase();

        function validate(value) {
            if (!value) {
                const idx = invalidDateFieldIds.indexOf(field.id);
                if (idx !== -1) invalidDateFieldIds.splice(idx, 1);
                return;
            }

            const parsed = Datepicker.parseDate(value, dateFormat, i18n.locale);
            const isValid = parsed && Datepicker.formatDate(parsed, dateFormat, i18n.locale) === value;
            const idx = invalidDateFieldIds.indexOf(field.id);

            if (isValid) {
                if (idx !== -1) invalidDateFieldIds.splice(idx, 1);
            } else {
                if (idx === -1) invalidDateFieldIds.push(field.id);
            }
        }

        return m(".form-section.with-button", [
            m("input.form-input.calendar[type=text]", {
                value: field.value,
                placeholder: field.info || DateUtilities.getLocaleDateString(i18n.locale),

                oninput: function (e) {
                    dirtyFlag(true);
                    field.value = e.target.value;
                },

                onblur: function (e) {
                    const value = e.target.value;
                    field.value = value;
                    validate(value);
                }
            }),

            m("button[type=button]",
                m(CalendarDay, { width: 14, height: 14 })
            )
        ]);
    }
};

export default DateInput;
